// extracted by mini-css-extract-plugin
module.exports = {"warningIcon":"style_warningIcon__13He6Z8_A39O5FqSm67xAL"};